<template>
  <div class="modalViewExport">
    <h3> {{ $t("authorcards.outputChoice") }} </h3>
    <p class="exportMessage"> {{ $t("authorcards.export") }} {{ Math.min($store.state.resultCount, 100) }} {{ $t("authorcards.records") }} </p>
    <div class="line"></div>
    <div class="exportSection">
      
      <div>
        <h3> {{ $t("results.format") }} </h3>
        <div class="exportSelectFormats">
          <input class="exportMethodbutton" type="button" value="JSON" @click="activeExportElement = 'json'"  :class="{ active : activeExportElement == 'json' }">
          <input class="exportMethodbutton" type="button" value="CSV" @click="activeExportElement = 'csv'"  :class="{ active : activeExportElement == 'csv' }">
          <input class="exportMethodbutton" type="button" value="Excel"  @click="activeExportElement = 'xlsx'" :class="{ active : activeExportElement == 'xlsx' }">
        </div>
      </div>
    </div>
    <div class="exportMenu">
      <button class="backbutton" @click="$root.exportModalShow = !$root.exportModalShow"> {{ $t("results.backbutton") }} </button>   
      <button class="exportbutton" @click="callExportMethod"> {{ $t("leftSideMenu.exportbutton") }} </button>
    </div>
  </div>  
</template>

<script>

export default {
    name: "ExportMenu",
    data(){
        return{
          activeExportElement: 'json',
        }
    },
    methods: {
      callExportMethod () {
        
        this.$store.dispatch('export', this.activeExportElement)
      }
    }
}
</script>

<style lang="scss"  scoped src="@/assets/css/ExportMenu.scss"/>